import { render, staticRenderFns } from "./ProvidentFundInfo.vue?vue&type=template&id=61dd18be&scoped=true&"
import script from "./ProvidentFundInfo.vue?vue&type=script&lang=js&"
export * from "./ProvidentFundInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd18be",
  null
  
)

export default component.exports